import React, { useEffect, useState } from 'react';
import CookieConsentDialog from './Dialog';

const CookieConsent = () => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const hasAccessToken = Boolean(localStorage.getItem('accessToken'));
    if (
      /EU_COOKIE_LAW_CONSENT=/.test(document.cookie) || hasAccessToken
    ) {
      setShow(false);
    }
  }, []);

  return show && <CookieConsentDialog />;
};

export default CookieConsent;
